import classNames from 'classnames'
import { capitalizeFirstLetter } from 'shared/utils'
import Icon from '@components/Icon'

const IconButton = ({ className = '', alt, onClick, onMouseEnter, icon, size = 'xl', isActive = false }) => {
    const title = capitalizeFirstLetter(alt)
    const btnClass = classNames('nav-icon-button', className)

    return (
        <button title={title} className={btnClass} onClick={onClick} onMouseEnter={onMouseEnter}>
            <div>
                <Icon type={icon} size={size} isActive={isActive} />
            </div>
        </button>
    )
}

IconButton.propTypes = {
    isActive: PropTypes.bool,
    alt: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    icon: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['xxxs', 'xxs', 'xs', 'sm', 'smd', 'md', 'lg', 'xl', 'xxxl']),
    className: PropTypes.string,
}

export default IconButton
